import { createAppRequest } from '@/services/request';

export interface OpenPlatformTokenResult {
  accessToken: string;
}

export interface TaskManagementTokenResult {
  accessToken: string;
  expiresAt?: number;
}

export function getOpenPlatformToken() {
  return createAppRequest()<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}

export function getTaskManagementToken() {
  return createAppRequest()<TaskManagementTokenResult>(
    '/bff/open-platform/task-management-token',
    { method: 'GET' },
  );
}
